import axiosConfig from "./axiosConfig";

interface HhDataTempLogsRequest {
  log_payload: any;
}

interface HhDataTempLogsResponse {
  logs_url: string;
  site_id: string;
  request_id: string;
  object_key: string;
  log_count: number;
  message: string;
}

const postHhDataTempLogs = async (
  authToken: string,
  fileGuid: string,
  request: HhDataTempLogsRequest
): Promise<HhDataTempLogsResponse> => {
  const { data } = await axiosConfig.post(
    `/hh_data/temp/${fileGuid}/logs`,
    request,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postHhDataTempLogs;
